// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"063ee10a","208":"75270a1a","293":"ec8bd81f","516":"23c37939","917":"945c90dd","946":"86009f5f"}[chunkId] + ".chunk.js";
};